import api from './api';

// Discounts & Trade Spend (bud_discounts), scoped to a budget version.
export const discountService = {
  // level: 'customer' | 'group'; period: 1..12 (the primary month being viewed).
  getDiscounts: async (versionId, { level, period }) => {
    const response = await api.get(`/discounts/${versionId}`, { params: { level, period } });
    return response.data;
  },
  // payload: { version_id, level, financial_periods: [...], rows: [{ entity_code, discount_code, value }] }
  upsertDiscounts: async (payload) => {
    const response = await api.post('/discounts', payload);
    return response.data;
  },

  // Config: which discount types are shown on the editing screen (company-level).
  getConfig: async () => {
    const response = await api.get('/discounts/config');
    return response.data;
  },
  // payload: { items: [{ discount_code, is_enabled }] }
  upsertConfig: async (payload) => {
    const response = await api.post('/discounts/config', payload);
    return response.data;
  },
};

export default discountService;
